var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.title))]),_vm._v(" - "+_vm._s(_vm.message)+". "),(_vm.link)?_c('a',{attrs:{"href":_vm.link}},[_vm._v("View")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }